const PATHS = {
  flower: (
    <>
      <path d="M32 58 C32 46 32 36 32 28" />
      <path d="M32 42 C24 40 19 34 19 27 C26 29 30 34 32 38" />
      <path d="M32 48 C40 46 45 40 45 33 C38 35 34 40 32 44" />
      <circle cx="32" cy="19" r="6.5" />
      <path d="M32 6 C33.5 10 33.5 10 32 12.5 M24 11 C27.5 13 27.5 13 29 15.5 M40 11 C36.5 13 36.5 13 35 15.5" />
    </>
  ),
  needle: (
    <>
      <path d="M12 52 L46 18" />
      <path d="M46 18 L55 9" />
      <path d="M41 13 L51 23" />
      <circle cx="12" cy="52" r="2.5" />
      <path d="M20 46 C27 45 31 41 31 34" />
    </>
  ),
  ring: (
    <>
      <circle cx="32" cy="35" r="15" strokeDasharray="78 16" />
      <circle cx="45" cy="21" r="4" />
    </>
  ),
  wave: (
    <>
      <path d="M6 18 C14 10 22 10 30 18 C38 26 46 26 54 18" />
      <path d="M6 30 C14 22 22 22 30 30 C38 38 46 38 54 30" />
      <path d="M6 42 C14 34 22 34 30 42 C38 50 46 50 54 42" />
    </>
  ),
  machine: (
    <>
      <rect x="18" y="10" width="28" height="20" rx="4" />
      <circle cx="26" cy="20" r="4" />
      <circle cx="38" cy="20" r="4" />
      <path d="M32 30 L32 48" />
      <path d="M28 48 L36 48 L34 56 L30 56 Z" />
      <path d="M46 14 L54 6" />
    </>
  ),
  flash: (
    <>
      <path d="M32 8 L35 27 L54 32 L35 37 L32 56 L29 37 L10 32 L29 27 Z" />
      <circle cx="32" cy="32" r="2" />
    </>
  ),
};

export const Motif = ({ type = "flower", className = "" }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {PATHS[type]}
  </svg>
);
